/**
 * PrintDocumentRoot — the shell every isolated print document renders into.
 *
 * Mounted into <body> (outside the app root) and marked [data-print-root].
 * While body[data-print-isolate] is set (useIsolatedPrint), styles/global.css
 * hides every other body child, so only this subtree reaches paper. On
 * screen it is laid out off-screen and invisible, so images load and
 * sizes can be measured before window.print().
 */
import type { ReactNode } from 'react';
import { createPortal } from 'react-dom';
import styles from './PrintDocumentRoot.module.css';

interface PrintDocumentRootProps {
  title: string;
  subtitle?: string | null;
  testId: string;
  children: ReactNode;
}

const PrintDocumentRoot: React.FC<PrintDocumentRootProps> = ({ title, subtitle, testId, children }) =>
  createPortal(
    <div className={styles.root} data-print-root="" data-testid={testId} aria-hidden="true">
      <h1 className={styles.title}>{title}</h1>
      {subtitle && <div className={styles.subtitle}>{subtitle}</div>}
      {children}
    </div>,
    document.body,
  );

export default PrintDocumentRoot;
